import { IconArchive } from "@tabler/icons-react";
import { FileDropzone } from "@/components/ui";
import { toastError } from "@/lib/toast";

interface Props {
  cargando: boolean;
  onFile: (zip: File) => void;
}

export function ZipDropzone({ cargando, onFile }: Props) {
  const handleFile = (file: File) => {
    if (!file.name.toLowerCase().endsWith(".zip")) {
      toastError({ title: "Archivo no válido", message: "Selecciona un archivo .zip" });
      return;
    }
    onFile(file);
  };
  return (
    <FileDropzone
      titulo="Sube el archivo ZIP"
      descripcion="Mínimo 2 CFDIs viables · todos deben tener el mismo RFC receptor (validación F6)."
      accept=".zip"
      Icon={IconArchive}
      cargando={cargando}
      ctaTexto={cargando ? "Procesando ZIP…" : "Arrastra el ZIP aquí o haz clic para seleccionarlo"}
      hint="Pares XML+PDF · todos con mismo RFC receptor"
      onFile={handleFile}
    />
  );
}
